import { DeleteConfirmationDialog } from '@components/dialogs/DeleteConfirmationDialog'
import { DataTable } from '@components/tables'
import { Container, Dialog, DialogContent, Grid, Paper } from '@mui/material'
import { GridColumns, GridRowId } from '@mui/x-data-grid-pro'
import { Actions } from '@state/actions'
import { useSelector } from '@state/store'
import { findAllRooms, removeLabWorkstation } from '@state/thunks/roomThunk'
import { findAll as findAllSites } from '@state/thunks/siteThunk'
import theme from '@utils/theme'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { DialogTitle } from '@components/titles'
import { RoomType, Site } from '@services/api'
import { removeSites } from '@state/reducers/siteReducer'
import { LabWorkstationsForm } from './LabWorkstationsForm'

export default function LabWorkstations() {
  const dispatch = useDispatch()
  const [openAddDialog, setOpenAddDialog] = useState(false)
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const { loading, rooms } = useSelector(({ room, loading }) => ({
    rooms: room.rooms.filter((_room) => _room.type === RoomType.LabWorkstation),
    loading:
      loading[Actions.UPDATE_LAB_WORKSTATION] ||
      loading[Actions.CREATE_LAB_WORKSTATION] ||
      loading[Actions.ROOM_FIND_ALL],
  }))

  const columns2: GridColumns = [
    { field: 'label', headerName: 'Label', flex: 1 },
    { field: 'code', headerName: 'Code', flex: 1 },
    {
      field: 'site',
      headerName: 'Site',
      flex: 1,
      valueFormatter: (params) => {
        return (params.value as unknown as Site)?.label
      },
    },
  ]

  const onRefresh = useCallback(() => {
    dispatch(findAllRooms())
    dispatch(findAllSites())
  }, [dispatch])

  useEffect(() => {
    onRefresh()
    return () => {
      dispatch(removeSites())
    }
  }, [dispatch, onRefresh])

  const _onSelectionChange = (selection: GridRowId[]) => {
    setSelectedRows(selection as number[])
  }
  const _onDeleteConfirm = () => {
    dispatch(removeLabWorkstation({ id: selectedRows }))
    setIsDeleteDialogOpen(false)
  }

  return (
    <Container maxWidth={false} style={{ height: '93%', padding: '0px 24px' }}>
      <Paper
        elevation={2}
        style={{ width: '100%', borderRadius: '0px 15px 15px 15px' }}
      >
        <DataTable
          rows={rooms}
          columns={columns2}
          loading={loading}
          toolBarProps={{
            title: 'labWorkstations',
            icon: 'fab fa-uikit',
            onAdd: () => setOpenAddDialog(true),
            onRefresh,
            onDelete: () => {
              selectedRows.length
                ? setIsDeleteDialogOpen(true)
                : alert('please select at least one lab workstation')
            },
          }}
          detailPanelHeight={400}
          form={(props) => (
            <LabWorkstationsForm
              {...props}
              onClose={() => setOpenAddDialog(false)}
            />
          )}
          checkboxSelection
          onSelectionModelChange={_onSelectionChange}
        />
      </Paper>

      <Dialog
        open={openAddDialog}
        onClose={() => setOpenAddDialog(false)}
        maxWidth="lg"
        aria-labelledby="form-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: 5,
            minWidth: '50%',
            background: theme.palette.primary.main,
          },
        }}
      >
        <DialogTitle
          title="addLabWorkstation"
          onClose={() => setOpenAddDialog(false)}
          format
        />
        <DialogContent sx={{ background: '#fff', padding: '0px 10px' }}>
          <LabWorkstationsForm onClose={() => setOpenAddDialog(false)} />
        </DialogContent>
      </Dialog>

      <DeleteConfirmationDialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
        onConfirm={_onDeleteConfirm}
        title="Confirmer la suppression"
        description="Voulez-vous vraiment supprimer les postes de laboratoire sélectionnés ?"
      />
    </Container>
  )
}
